import { render, staticRenderFns } from "./IconCloseFull.vue?vue&type=template&id=012ae628&scoped=true&"
import script from "./IconCloseFull.vue?vue&type=script&lang=js&"
export * from "./IconCloseFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ae628",
  null
  
)

export default component.exports